import React, { useEffect, useState } from 'react';
import styles from './introC.module.scss';
import { routesApp } from '@/constans/routes';
import { generatePath, useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/useAuth';
import { eventsApi } from '@/api';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import introCBottomsheet from '@/assets/images/introCBottomsheetWithAggreement.png';
import clsx from 'clsx';
import { Spiner } from '@/ui-kit';
import { SignUpDesign, useSignUpDesign } from '@/store/useSignUpDesign';
import WebApp from '@twa-dev/sdk';
import { useVibration } from '@/store/useVibration';

export const IntroC: React.FC = () => {
    const { user, emptyFields, getUser, profileWasRemovedError } = useAuth((state) => state);
    const navigate = useNavigate();

    const {
        design: signUpScreen,
        setDesign
    } =
        useSignUpDesign((state) => state)

    // rt15161: a/b test of sign up
    const generateSignUpPath = () => {
        let design: SignUpDesign =
            signUpScreen
        if (user) {
            setDesign(user?.registration_design)
            design = user?.registration_design
        }
        return generatePath(
            design === 'new_skip_steps' ?
                routesApp.registrationV4
            : design === 'new_photo_last' ?
                routesApp.registrationV3
            : design === 'new' ?
                routesApp.registrationV2
            :
                routesApp.registration,
            { stepNumer: '1' }
        );
    }

    useEffect(() => {
        let path: string | null = null;

        if (
            emptyFields() ||
            profileWasRemovedError
        ) {
            // Ничего не делаем, если есть незаполненные поля
            eventsApi.updateUserEvent('start_screen');
            callYaMetrika('first_screen_loaded', {
                first_screen: 'C'
            });
            return;
        }

        if (getUser()?.state === 'incomplete') {

            // Если пользователь не завершил регистрацию
            path = generateSignUpPath();
        } else {
            // Если пользователь завершил регистрацию
            path = generatePath(routesApp.browse);
        }

        if (path) {
            navigate(path, { replace: true });
        }
    }, [emptyFields, navigate, user]);

    const { isVibrationEnabled } =
        useVibration(state => state);

    const registerClick = () => {
        callYaMetrika('clicked_registration_button');
        navigate(
            generateSignUpPath()
        );
        if (isVibrationEnabled) {
            WebApp
                .HapticFeedback
                .impactOccurred('medium');
            // pass for not android
            navigator.vibrate?.(10)
        }
    };

    const [isLoading, setLoading] = useState(true)

    return (
        <>
            <section className={styles.intro}>
                <div className={styles.intro__content}>
                    {isLoading && <Spiner />}
                    <img
                        className={clsx(styles.introCard, isLoading && styles['introCard--loading'])}
                        src={introCBottomsheet}
                        onLoad={() => setLoading(false)}
                        onClick={registerClick} />
                </div>
            </section>
        </>
    );
};
